import { Link } from 'react-router-dom';
import ArticleLayout from './components/ArticleLayout';

export default function AnfaengerPage() {
  return (
    <ArticleLayout
      title="OOPBUY für Anfänger – Der komplette Einsteiger-Guide 2026"
      description="Neu bei OOPBUY Spreadsheet? Kein Problem! Dieser Anfänger-Guide erklärt Schritt für Schritt, wie du OOPBUY einrichtest, dein erstes Spreadsheet nutzt und typische Fehler vermeidest. Perfekt für komplette Neueinsteiger."
      heroImage="https://readdy.ai/api/search-image?query=clean%20organized%20desk%20with%20notebook%20and%20pen%20on%20warm%20beige%20surface%2C%20beginner%20guide%20concept%2C%20soft%20natural%20daylight%2C%20minimalist%20photography%2C%20warm%20neutral%20tones%2C%20fresh%20start%20aesthetic%2C%20European%20style&width=1600&height=600&seq=article-hero-anfaenger&orientation=landscape"
      heroImageAlt="OOPBUY Anfänger Guide"
      pageUrl="/oopbuy-anfaenger"
      relatedArticles={[
        { title: 'OOPBUY Spreadsheet Guide', path: '/oopbuy-spreadsheet-guide' },
        { title: 'OOPBUY Sicherheit', path: '/oopbuy-sicherheit' },
        { title: 'OOPBUY QC Guide', path: '/oopbuy-qc-guide' },
        { title: 'OOPBUY Kosten sparen', path: '/oopbuy-kosten-sparen' },
      ]}
    >
      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Willkommen bei OOPBUY Spreadsheet!</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Du bist neu in der Welt von <strong>OOPBUY Spreadsheet</strong> und fragst dich, wo du anfangen sollst? Keine Sorge — dieser Guide führt dich Schritt für Schritt durch den gesamten Prozess, von der ersten Registrierung bis zur ersten erfolgreichen Bestellung.
        </p>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
          Grundlegende Informationen findest du auch im <Link to="/oopbuy-spreadsheet-guide" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Spreadsheet Guide</Link>.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Schritt 1: OOPBUY Konto erstellen</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Der erste Schritt ist einfach: Erstelle ein kostenloses Konto auf der OOPBUY-Plattform. Du benötigst lediglich eine gültige E-Mail-Adresse. Nach der Registrierung kannst du sofort mit dem Entdecken der Spreadsheet-Listen beginnen.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Schritt 2: Dein erstes Spreadsheet finden</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Ein <strong>OOPBUY Spreadsheet</strong> ist eine strukturierte Tabelle mit Produktempfehlungen, Preisen und Verkäuferinformationen. Hier sind die wichtigsten Arten von Spreadsheets, die du finden kannst:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          <div className="p-3 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">Kategorie-Spreadsheets</h3>
            <p className="text-foreground-600 text-xs">Fokussiert auf eine Produktkategorie wie Sneaker, Hoodies oder Accessoires.</p>
          </div>
          <div className="p-3 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">Budget-Spreadsheets</h3>
            <p className="text-foreground-600 text-xs">Speziell für preisbewusste Käufer mit Fokus auf günstige Alternativen.</p>
          </div>
          <div className="p-3 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">Designer-Spreadsheets</h3>
            <p className="text-foreground-600 text-xs">Hochwertige und luxuriöse Produkte für anspruchsvolle Käufer.</p>
          </div>
          <div className="p-3 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">Trend-Spreadsheets</h3>
            <p className="text-foreground-600 text-xs">Aktuelle Trendprodukte und saisonale Highlights.</p>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Die 5 häufigsten Anfängerfehler</h2>
        <div className="space-y-3">
          <div className="flex items-start gap-3 p-3 bg-red-50/60 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-close-circle-line text-red-500"></i></span>
            <p className="text-foreground-700 text-sm"><strong>Zu schnell bestellen:</strong> Nimm dir Zeit, QC-Bilder zu prüfen und Bewertungen zu lesen, bevor du eine Bestellung aufgibst.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-red-50/60 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-close-circle-line text-red-500"></i></span>
            <p className="text-foreground-700 text-sm"><strong>Versandkosten ignorieren:</strong> Die günstigsten Produkte sind nicht immer die beste Wahl, wenn die Versandkosten hoch sind.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-red-50/60 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-close-circle-line text-red-500"></i></span>
            <p className="text-foreground-700 text-sm"><strong>Zoll vergessen:</strong> Informiere dich vorab über Zollgebühren bei der Einfuhr nach Deutschland.</p>
          </div>
        </div>
        <p className="text-foreground-600 text-sm mt-4">
          Mehr zum Thema Sicherheit findest du im <Link to="/oopbuy-sicherheit" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Sicherheitsguide</Link>.
        </p>
      </section>
    </ArticleLayout>
  );
}